// extracted by mini-css-extract-plugin
export default {"shows":"shows_shows__sJZ0X","intro":"shows_intro__AbD+o","title":"shows_title__yibgc","info":"shows_info__ML5LB","infoActions":"shows_infoActions__lpELT","btn":"shows_btn__yla+G"};